import { Select } from "antd";
import React from "react";

const SelectField = ({
  containerStyle,
  value,
  defaultValue,
  options,
  inputStyle,
  onSelect,
  onSearch,
  onChange,
  placeholder,
  allowClear = true,
  notFoundContent = true,
  size,
  mode,
  ...props
}) => {
  return (
    <div style={containerStyle}>
      <Select
        defaultValue={defaultValue}
        allowClear={allowClear}
        value={value}
        notFoundContent={notFoundContent}
        options={options}
        style={inputStyle}
        onSelect={onSelect}
        onChange={onChange}
        placeholder={placeholder}
        size={size}
        mode={mode}
        {...props}
      />
    </div>
  );
};

export default SelectField;
